import React, { Component } from 'react';

import { CopyButton } from '~/eds/src/components/Button/subcomponents/CopyButton';
import { Card } from '~/eds/src/components/Card/Card';
import { EmailInput } from '~/eds/src/components/EmailInput/EmailInput';
import { FormField } from '~/eds/src/components/FormField/FormField';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Text } from '~/eds/src/components/Text/Text';
import { injectIntl } from 'react-intl';

class EmailSettings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inboundEmail: '',
      copied: false,
    };
  }

  componentDidMount() {
    const { inboundEmail } = this.props;

    this.setState({ inboundEmail });
  }

  render() {
    const { inboundEmail } = this.state;
    const { intl } = this.props;

    return (
      <Card
        header={{
          title: intl.formatMessage({
            id: 'EmailSettings.emailSettingsTitle',
            defaultMessage: 'Email Settings',
            description: 'Title for the email settings section',
          }),
        }}
        mode="bordered"
      >
        <Layout preset="form-fields">
          <Text preset="description">
            {intl.formatMessage({
              id: 'EmailSettings.emailIntakeDescription',
              defaultMessage:
                'Email Intake allows you to set up a way to import documents into Evisort by emailing them to a special address.',
              description: 'Description for email intake settings',
            })}
          </Text>
          <FormField
            disabled
            label={intl.formatMessage({
              id: 'EmailSettings.intakeEmailLabel',
              defaultMessage: 'Intake Email',
              description: 'Label for the intake email field',
            })}
            input={EmailInput}
            inputProps={{
              width: 'input.l.width',
            }}
            value={inboundEmail}
          />
          <CopyButton
            copyText={inboundEmail}
            copiedToastMessage={intl.formatMessage({
              id: 'EmailSettings.emailCopiedMessage',
              defaultMessage: 'Email address copied to clipboard',
              description: 'Message shown when email address is copied',
            })}
          />
        </Layout>
      </Card>
    );
  }
}

export default injectIntl(EmailSettings);
